import ReactDOM from 'react-dom/client';
import 'react-app-polyfill/ie11';
import { Suspense, lazy } from 'react';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import 'primereact/resources/primereact.css';

import './assets/layout/layout.scss';
import './App.scss';

import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';
// import * as serviceWorker from './serviceWorker';
import ScrollToTop from './ScrollToTop';

const App = lazy(async () => await import('./App'));

if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
  console.info = () => { };
  console.debug = () => { };
  // console.error and console.warn can stay active if you wish to track production errors
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Router>
    <Suspense fallback={<p>Cargando</p>}>
      <ScrollToTop>
        <Switch>
          {/* Ruta dinámica con parámetro */}
          {/* <Route exact path="/:parametro" component={CursosInicio} /> */}

          {/* Ruta para la aplicación principal */}
          <App></App>
        </Switch>
      </ScrollToTop>
    </Suspense>
  </Router>
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
